module.exports = __webpack_public_path__ + "img/tram.53e66ecb.svg";